import React from "react";
import * as St from "../styles/header.style";

function Header() {
  return (
    <St.Title>
      <span>☁️ Welcome to To Do List! ⛅️</span>
    </St.Title>
  );
}

export default Header;
